

















import { defineComponent, PropType } from "@vue/composition-api"
import { IScholarships } from "@/apps/StudentExchangeOverviewWidget/models/scholarships-viewmodel"
import ExchangeRow from "@/apps/StudentExchangeOverviewWidget/components/molecules/ExchangeRow.vue"

export default defineComponent({
    name: "Scholarships",
    components: {
        ExchangeRow
    },
    props: {
        scholarships: {
            type: Array as PropType<IScholarships>,
            required: true,
            default: () => []
        },
        programOfStudyId: {
            type: Number,
            required: true,
            default: null
        },
        academicYearId: {
            type: String,
            required: true,
            default: null
        },
    }
})
